import { Pencil2Icon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";
import { LeaveApplication } from "./schema";
import { useViewModal } from "../view-leave-application-modal/use-view-modal";
import { Trash } from "lucide-react";
import { useDeleteLeaveApplicationModal } from "../delete-leave-application/use-delete-leave-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as LeaveApplication;

  const { onOpenChange: onViewModalChange, setLeaveApplication } =
    useViewModal();

  const { setLeaveId, onOpenChange } = useDeleteLeaveApplicationModal();

  return (
    <div className="flex items-center gap-3">
      <Button
        size="icon"
        className="w-6 h-6"
        onClick={() => {
          setLeaveApplication(originData);
          onViewModalChange(true);
        }}
      >
        <Pencil2Icon />
      </Button>

      <Button
        size="icon"
        variant="destructive"
        className="w-6 h-6"
        onClick={() => {
          setLeaveId(originData?.id);
          onOpenChange(true);
        }}
      >
        <Trash className="w-4 h-4" />
      </Button>
    </div>
  );
}
